import { useState } from 'react';
import { Typography } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import ConfirmationModal from 'components/new-ui/composed/modal/confirmation-modal/ConfirmationModal';
import useInvoices from 'hooks/useInvoices';
import { InvoicesStatuses } from 'store/invoices/types';
import Notification from 'components/ui/base/notification/Notification';
import { getErrorMessage } from 'utils/getErrorMessage';
import { DEFAULT_INTERNAL_ERROR_MESSAGE } from 'core/utils/constants';
import { Events } from 'utils/events.enum';

type Props = {
    invoiceId: string;
    open: boolean;
    onClose: () => void;
    onConfirm?: () => void;
};

const MarkAsPaidModal = ({ invoiceId, open, onClose }: Props) => {
    const { updateInvoiceStatus } = useInvoices();
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async () => {
        try {
            await updateInvoiceStatus(invoiceId, {
                status: InvoicesStatuses.PAID,
            });

            onClose();

            Notification({
                type: 'success',
                messageTitle: 'Invoice Updated',
                description: 'Invoce successfully marked as paid.',
            });

            window.EventBus.publish(Events.INVOICE_HISTORY_UPDATED);
        } catch (error) {
            const errMessage = getErrorMessage(error) || DEFAULT_INTERNAL_ERROR_MESSAGE;
            Notification({
                type: 'error',
                messageTitle: 'Operation Failed',
                description: errMessage,
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <ConfirmationModal
            type="success"
            open={open}
            icon={<CheckOutlined />}
            title="Confirm Payment"
            confirmButtonText="Mark as Paid"
            confirmationButtonLoading={isSubmitting}
            onConfirm={handleSubmit}
            onCancel={onClose}
            content={
                <div
                    style={{
                        textAlign: 'left',
                        width: '100%',
                        paddingBottom: 16,
                    }}
                >
                    <Typography.Text>Are you sure you want to mark this invoice as paid?</Typography.Text>
                </div>
            }
        />
    );
};

export default MarkAsPaidModal;
